// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cis-countries-collapsible {
  width: 100%;
  min-width: 100%;
}

.cis-countries-collapsible__item {
  display: flex;
  flex-direction: row;
  width: 100%;
  background-color: #ebd9cd;
  border-radius: 10px;
  gap: 20px;
}
.cis-countries-collapsible__item__header {
  display: flex;
  flex-direction: row;
  font-size: 18px;
  line-height: 18px;
  font-weight: bold;
  gap: 5px;
  align-items: flex-start;
}
.cis-countries-collapsible__item__header__note {
  font-size: 12px;
  line-height: 12px;
  font-weight: normal;
}
.cis-countries-collapsible__item__header__button {
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 30px;
  min-height: 30px;
  border-radius: 100px;
  background-color: #F5EFE7;
  transition: transform 0.5s ease-in-out;
  transform-origin: center;
  transform: rotate(45deg) translateZ(0);
  will-change: transform;
  overflow: hidden;
}
@media (hover: hover) {
  .cis-countries-collapsible__item__header__button:hover {
    outline: 2px solid #213555;
  }
}
.cis-countries-collapsible__item__header__button__symbol {
  display: inline-block;
  color: #213555;
  font-family: Twemoji Country Flags, Segoe UI Symbol, Consolas;
  font-size: 18px;
  line-height: 18px;
  transform: translateZ(0);
  will-change: transform;
}

.country-list-table {
  margin-top: 10px;
  background-color: #f1e2d7;
  border-radius: 10px;
}
.country-list-table tr > td {
  border-top: 1px dotted #213555;
  border-top: 1px dashed #213555;
}
.country-list-table tr:first-child > td {
  border: 0;
}
.country-list-table td {
  padding: 5px 10px;
}
@media (max-width: 720px) {
  .country-list-table {
    width: 100%;
    font-size: 14px;
  }
  .country-list-table td {
    padding: 2px;
  }
}`, "",{"version":3,"sources":["webpack://./src/sections/IntroductionSection/components/CisCountriesCollapsible.scss","webpack://./src/utils/_themeConstants.scss"],"names":[],"mappings":"AAEA;EACE,WAAA;EACA,eAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,yBCNY;EDOZ,mBAAA;EACA,SAAA;AADF;AAGE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,QAAA;EACA,uBAAA;AADJ;AAGI;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;AADN;AAII;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,yBC9BS;EDgCT,sCAAA;EACA,wBAAA;EACA,sCAAA;EACA,sBAAA;EACA,gBAAA;AAJN;AAMM;EACE;IACE,0BAAA;EAJR;AACF;AAOM;EACE,qBAAA;EACA,cCtDK;EDuDL,6DAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,sBAAA;AALR;;AAWA;EACE,gBAAA;EACA,yBC7Da;ED8Db,mBAAA;AARF;AAUE;EACE,8BAAA;EACA,8BAAA;AARJ;AAUE;EACE,SAAA;AARJ;AAWE;EACE,iBAAA;AATJ;AAYE;EAjBF;IAkBI,WAAA;IACA,eAAA;EATF;EAWE;IACE,YAAA;EATJ;AACF","sourcesContent":["@use '../../../utils/themeConstants';\r\n\r\n.cis-countries-collapsible {\r\n  width: 100%;\r\n  min-width: 100%;\r\n}\r\n\r\n.cis-countries-collapsible__item {\r\n  display: flex;\r\n  flex-direction: row;\r\n  width: 100%;\r\n  background-color: themeConstants.$color-light;\r\n  border-radius: 10px;\r\n  gap: 20px;\r\n\r\n  &__header {\r\n    display: flex;\r\n    flex-direction: row;\r\n    font-size: 18px;\r\n    line-height: 18px;\r\n    font-weight: bold;\r\n    gap: 5px;\r\n    align-items: flex-start;\r\n  \r\n    &__note {\r\n      font-size: 12px;\r\n      line-height: 12px;\r\n      font-weight: normal;\r\n    }\r\n\r\n    &__button {\r\n      display: flex;\r\n      justify-content: center;\r\n      align-items: center;\r\n    \r\n      min-width: 30px;\r\n      min-height: 30px;\r\n      border-radius: 100px;\r\n      background-color: themeConstants.$color-bright;\r\n    \r\n      transition: transform 0.5s ease-in-out;\r\n      transform-origin: center;\r\n      transform: rotate(45deg) translateZ(0);\r\n      will-change: transform;\r\n      overflow: hidden;\r\n    \r\n      @media (hover: hover) {\r\n        &:hover {\r\n          outline: 2px solid themeConstants.$color-dark;\r\n        }\r\n      }\r\n    \r\n      &__symbol {\r\n        display: inline-block;\r\n        color: themeConstants.$color-dark;\r\n        font-family: Twemoji Country Flags, Segoe UI Symbol, Consolas;\r\n        font-size: 18px;\r\n        line-height: 18px;\r\n        transform: translateZ(0);\r\n        will-change: transform;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.country-list-table {\r\n  margin-top: 10px;\r\n  background-color: themeConstants.$color-light1;\r\n  border-radius: 10px;\r\n\r\n  tr > td {\r\n    border-top: 1px dotted themeConstants.$color-dark;\r\n    border-top: 1px dashed themeConstants.$color-dark;\r\n  }\r\n  tr:first-child > td {\r\n    border: 0;\r\n  }\r\n\r\n  td {\r\n    padding: 5px 10px;\r\n  }\r\n\r\n  @media (max-width: 720px) {\r\n    width: 100%;\r\n    font-size: 14px;\r\n\r\n    td {\r\n      padding: 2px;\r\n    }\r\n  }\r\n}","$color-dark: #213555;\r\n$color-dark-highlight: #3E5879;\r\n\r\n$color-medium: #D8C4B6;\r\n\r\n$color-light: #ebd9cd;\r\n$color-light1: #f1e2d7;\r\n\r\n$color-bright: #F5EFE7;\r\n$color-brightest: #fff9f2;\r\n\r\n$mobile-cutoff-width: 720px;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
